export const pickKeyFromAnArray = (records: any[], keyName: string) => {
  let finalRecords: any[] = []
  records.map(record => {
    finalRecords.push(record[keyName])
  })
  return finalRecords
}
